import { z } from 'zod'
import { LegalTermType, type LegalTerm } from '../../models/LegalTerm'

export const LegalTermDTO = z.object({
  id: z.number().nullish(),
  type: z.nativeEnum(LegalTermType),
  title: z.string().nullable(),
  text: z.string().nullable(),
  version: z.string().nullish(),
  external_link: z.string().nullish(),
  app_id: z.number().nullish(),
  legal_term_id: z.number().nullish()
})

export type LegalTermDTO = z.infer<typeof LegalTermDTO>

export function mapLegalTermToDTO (model: LegalTerm): LegalTermDTO {
  const hasExternalLink = (model.externalLink?.trim().length ?? 0) > 0

  return {
    id: model.id,
    type: model.type,
    title: model.title,
    text: hasExternalLink ? null : model.text,
    version: model.version,
    external_link: hasExternalLink ? model.externalLink : undefined,
    app_id: model.appId,
    legal_term_id: model.legalTermId
  }
}

export function mapDTOToLegalTerm (dto: LegalTermDTO): LegalTerm {
  return {
    id: dto.id ?? undefined,
    type: dto.type,
    title: dto.title ?? '',
    text: dto.text ?? '',
    version: dto.version ?? undefined,
    externalLink: dto.external_link ?? undefined,
    appId: dto.app_id ?? undefined,
    legalTermId: dto.legal_term_id ?? undefined
  }
}
